import { render, staticRenderFns } from "./UsersAdd.vue?vue&type=template&id=3b093360&scoped=true"
import script from "./UsersAdd.vue?vue&type=script&lang=js"
export * from "./UsersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b093360",
  null
  
)

export default component.exports